import { useState, useEffect } from "react";
import type { CheckResult, RunSummary } from "../lib/types.js";

const API_URL = import.meta.env.VITE_API_URL ?? "/api";

export function useRunStream(runId: string | null) {
  const [results, setResults] = useState<CheckResult[]>([]);
  const [summary, setSummary] = useState<RunSummary | null>(null);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (!runId) return;

    setResults([]);
    setSummary(null);
    setIsComplete(false);

    let retries = 0;
    let es: EventSource;

    function connect() {
      es = new EventSource(`${API_URL}/runs/${runId}/stream`);

      es.addEventListener("check_result", (e) => {
        const data = JSON.parse((e as MessageEvent<string>).data) as CheckResult & { url: string };
        setResults((prev) => [...prev, data]);
      });

      es.addEventListener("run_complete", (e) => {
        const data = JSON.parse((e as MessageEvent<string>).data) as RunSummary;
        setSummary(data);
        setIsComplete(true);
        es.close();
      });

      es.onerror = () => {
        es.close();
        if (retries < 5) {
          retries++;
          setTimeout(connect, 2000);
        }
      };
    }

    connect();
    return () => es?.close();
  }, [runId]);

  return { results, summary, isComplete };
}
